"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StingingSwarmAbilityHandler = exports.StingingSwarmActorAbilityFactory = exports.StingingSwarmAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const __1 = require("../..");
class StingingSwarmAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.StingingSwarm;
        this.__typeName = "StingingSwarm";
    }
}
exports.StingingSwarmAbilityArgs = StingingSwarmAbilityArgs;
let StingingSwarmActorAbilityFactory = class StingingSwarmActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("StingingSwarm", "OneEnemies", 0);
    }
};
StingingSwarmActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("StingingSwarm")
], StingingSwarmActorAbilityFactory);
exports.StingingSwarmActorAbilityFactory = StingingSwarmActorAbilityFactory;
let StingingSwarmAbilityHandler = class StingingSwarmAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.applyProjectiles({
                    projectiles: [{
                            jitter: 0,
                            type: "GreenBlueOrangeComet",
                            path: "arc",
                            creatorId: ability.invokerId,
                            targetId: selectedEnemy,
                        }],
                    sequence: sequence.pushSequence("sequential"),
                    onProjectile(sequence, { targetId }) {
                        container.applyDebuff({
                            attackerId: ability.invokerId,
                            targetId: targetId,
                            duration: Duration_1.Duration.Turns(8),
                            effect: new __1.StingingSwarmEffectArgs("Focus", 10),
                            sequence: sequence.pushSequence("sequential"),
                        });
                        container.applyDebuff({
                            attackerId: ability.invokerId,
                            targetId: targetId,
                            duration: Duration_1.Duration.Ticks(8),
                            effect: new __1.LinkedEffectsEffectArgs([
                                new __1.MaxAttributeDecreaseEffectArgs(__1.AttributeType.NatureDamageImmunity, 25),
                                new __1.MaxAttributeDecreaseEffectArgs(__1.AttributeType.Will, container.getPercentOfBaseAttributeScore(selectedEnemy, 10, "Will")),
                                new __1.MaxAttributeDecreaseEffectArgs(__1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(selectedEnemy, 10, "Toughness"))
                            ], true),
                            sequence: sequence.pushSequence("sequential"),
                        });
                    }
                });
            }
        });
    }
};
StingingSwarmAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.StingingSwarm)
], StingingSwarmAbilityHandler);
exports.StingingSwarmAbilityHandler = StingingSwarmAbilityHandler;
